'use strict';

angular.module('AcaApp').factory('SettingsService',
[
  'SettingsResource',
  function(SettingsResource){
    return{
      getCurrentData: function(){
        var rpcConfig = {method: 'GetCurrentData', params: []};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      getNotes: function(){
        var rpcConfig = {method: 'GetNotes', params: []};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      saveNotes: function(note){
        var rpcConfig = {method: 'SaveNotes', params: [note]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      deleteNotes: function(noteKey){
        var rpcConfig = {method: 'DeleteNotes', params: [noteKey]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      updateNotes: function(note){
        var rpcConfig = {method: 'UpdateNotes', params: [note]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      updateTinMask: function(tinMask){
        var rpcConfig = {method: 'UpdateTinMask', params: [tinMask]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      getTinMaskSetting: function(){
        var rpcConfig = {method: 'GetTinMaskSetting', params: []};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      GetServicesStatus: function(){
        var rpcConfig = {method: 'GetSendServicesStatus', params: []};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      updateMfa: function(mfa) {
        var rpcConfig = {method: 'updateMFA', params: [mfa]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      getMfa: function() { 
        var rpcConfig = {method:'getMFA', params: []};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      changeTaxYear: function(taxYear){
        var rpcConfig = {method: 'ChangeTaxyear', params: [taxYear]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      updateTaxYearInJwt: function(taxYear){
        var rpcConfig = {method: 'updateTaxYearInJwt', params: [taxYear]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      getTaxYears: function(){
        var rpcConfig = {method: 'GetAvailableTaxyears', params: []};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      deleteCustomMap: function(mapName){
        var rpcConfig = {method: 'DeleteCustomMap', params: [mapName]};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      },
      getIndexedPDFCost: function(){
        var rpcConfig = {method: 'GetIndexedPDFCost', params: []};
        return SettingsResource.executeRpc(rpcConfig).$promise;
      }
    };
  }
]);